import React, { Component } from 'react';
import * as styled from './scroller.styled';
import $ from 'jquery';
import Row from './row/row';

class Scroller extends Component {

    constructor(props) {
        super();
        this.state = {
            data: null,
            render: true
        };
        this.load();
        this.isMobileVersion = props.isMobileVersion;
    }

    componentDidCatch(){}

    componentDidUpdate() {
        if (this.state.render) {
            if (this.isMobileVersion != this.props.isMobileVersion) {
                this.isMobileVersion = this.props.isMobileVersion;
                this.setState((state) => {return {...state, render: false};});
            }
        } else {
            this.setState((state) => {return {...state, render: true};})
        }
    }

    load() {
        $.ajax({
            url: './data/scroller.json',
            dataType: 'json'
        }).then((data) => {
            this.setState((state) => {
                return {...state, data};
            });
        });
    }

    render() {
        if (!this.state.render) return null;
        return (
            <styled.Scroller id="portfolio">
                {this.state.data ?
                    this.state.data.scrollers.map((row, index) => {
                        return (
                            <Row key={`scrollerRow${index}`} data={row} height={this.props.rowHeight} isMobileVersion={this.props.isMobileVersion} />
                        );
                    })
                : null}
            </styled.Scroller>
        );
    }
}

export default Scroller;